'use client';
import { config } from '@/apollo/config';
import { CATEGORY_LIST_QUERY } from '@/apollo/graphql/queries/categoryQueries/categoryQueries';
import { CategoryData } from '@/apollo/graphql/types/categoryTypes';
import MenuIcon from '@/assets/icons/icon-menu.svg';
import { Link } from '@/i18n/navigation';
import useCatalogStore from '@/zustand/useOpenCatalog';
import { useQuery } from '@apollo/client';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';
import { useWindowSize } from 'react-use';
import { Drawer } from 'rsuite';
import DrawerContent from '../drawer-content';
import styles from './header-bottom-mobile.module.scss';
import { useLanguageCode } from '@/hooks/useLanguageCode';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';

const HeaderBottomMobile = () => {
  const { open, setOpen } = useCatalogStore();
  const t = useTranslations('General');
  const { width } = useWindowSize();
  const languageCode = useLanguageCode();

  const { data, loading } = useQuery<CategoryData>(CATEGORY_LIST_QUERY, {
    variables: {
      first: 100,
      level: 0,
      languageCode: languageCode,
    },
  });

  const parentCategories =
    data?.categories?.edges
      ?.filter(
        edge =>
          edge.node.parent === null &&
          edge.node.isInCatalog === true &&
          edge.node.isBottom === false
      )
      .map(edge => edge.node) || [];

  return (
    <div className={styles.headerBottomMobile}>
      <div className={styles.categoriesMobile}>
        {loading
          ? Array.from({ length: 12 }).map((_, index) => (
              <div
                key={index}
                className={`${styles.categoryMobile} ${styles.skeleton}`}
              >
                <Skeleton />
              </div>
            ))
          : parentCategories.slice(0, 12).map(category => {
              return (
                <Link
                  href={`/catalog/${category.slug}/${decodeBase64Id(category.id)}`}
                  key={category.id}
                  className={styles.categoryMobile}
                >
                  <div>
                    <Image
                      src={`${config.publicApiUrl}${category?.icon}`}
                      alt={category.name}
                      className={styles.brandLogo}
                      width={32}
                      height={32}
                    />
                  </div>
                  <p>{category.name}</p>
                </Link>
              );
            })}
      </div>
      <button
        type="button"
        className={styles.iconBurgerMobile}
        onClick={() => setOpen(true)}
      >
        <MenuIcon />
        <span className={styles.headerBottom__catalog}>
          {t('catalog-products')}
        </span>
      </button>
      <Drawer
        size={`${
          width <= 767
            ? 'calc(100% - 0px'
            : width <= 1241
              ? 'calc(100% - 50px'
              : width <= 1510
                ? 'calc(100% - 100px'
                : width <= 1750
                  ? 'calc(100% - 258px'
                  : 'calc(100% - 490px'
        })`}
        placement="left"
        // backdrop="static"
        onClose={() => setOpen(false)}
        open={open}
        closeButton={false}
      >
        <Drawer.Body style={{ padding: '0' }}>
          <div style={{ height: '100%' }}>
            {' '}
            <DrawerContent closeButton={() => setOpen(false)} />
          </div>
        </Drawer.Body>
      </Drawer>
    </div>
  );
};

export default HeaderBottomMobile;
